export default __webpack_public_path__ + "static/media/pipelines-split.63396d27.svg";